const Contract = ({
    customerId = '',
    name = '',
} = {}) => ({
    customerId: String(customerId),
    name: String(name),
});

export default Contract;
